import { useQuery } from "@apollo/client";

import {
  CampaignSortBy,
  ListCampaignsQuery,
  ListCampaignsQueryVariables,
} from "~frontend/__generated__/graphql";
import { LIST_CAMPAIGNS } from "~frontend/graphql/campaigns";
import { useSubaccount } from "~frontend/providers/SubaccountProvider";

export function useCampaignNamesById({
  skip = false,
  limit = 50,
  filter,
}: {
  skip?: boolean;
  limit?: number;
  filter?: ListCampaignsQueryVariables["input"]["filter"];
} = {}): {
  campaigns: ListCampaignsQuery["listCampaigns"]["campaigns"];
  campaignNamesById: Record<string, string>;
  loading: boolean;
  error: unknown;
} {
  const { subaccount } = useSubaccount()!;

  const { data, loading, error } = useQuery<
    ListCampaignsQuery,
    ListCampaignsQueryVariables
  >(LIST_CAMPAIGNS, {
    variables: {
      input: {
        subaccountId: subaccount.id,
        sort: CampaignSortBy.CreatedAtDesc,
        limit,
        filter,
      },
    },
    skip,
  });

  const campaigns = data?.listCampaigns.campaigns || [];
  const campaignNamesById = Object.fromEntries(
    campaigns.map(c => [c.id, c.name])
  );

  return { campaigns, campaignNamesById, loading, error };
}
